import { jsx as _jsx } from "react/jsx-runtime";
import i18next from 'i18next';
import React from 'react';
import { Button } from '@famly/mf_input_button';
import { useBreakpoints } from '@famly/mf_util_breakpoints';
import { useAriaAndDataProps } from '@famly/mf_ts-utils_data-aria-props';
import { modalPrimaryActionProps } from './modal-primary-action-attribute';
import { SplitModalContext } from './split-modal';
/**
 * ModalPrimaryButton component
 *
 * The primary action button for modals, typically used for confirmations or saving.
 * Renders as a primary button with responsive sizing based on viewport width.
 *
 * - On mobile: Regular size
 * - On tablet and larger: Compact size
 *
 * Should be used inside ModalFooterButtons.
 *
 * It is the action the modal's `Cmd`/`Ctrl` + `Enter` shortcut triggers.
 *
 * @param {ModalPrimaryButtonProps} props - Component props
 * @param {ButtonProps['type']} [props.type='submit'] - Button type attribute
 * @param {ButtonProps['text']} [props.text='Confirm'] - Button text
 * @param {ButtonProps['icon']} [props.icon] - Optional icon to display in the button
 * @param {ButtonProps['variant']} [props.variant] - Optional variant override for the button
 * @param {ButtonProps['isDisabled']} [props.isDisabled] - Optional isDisabled in the button
 * @param {ButtonProps['isLoading']} [props.isLoading] - Optional isLoading state for the button
 *
 * @example
 * <ModalFooterButtons>
 *   <ModalPrimaryButton text="Save" onClick={handleSave} />
 * </ModalFooterButtons>
 */
export const ModalPrimaryButton = ({ type = 'submit', text, icon, isDisabled, isLoading, variant = 'primary', onClick, href, target, ...rest }) => {
    const { isTabletPortraitAndLarger } = useBreakpoints();
    const dataAriaProps = useAriaAndDataProps(rest);
    const context = React.use(SplitModalContext);
    return (_jsx(Button, { ...modalPrimaryActionProps, fullWidth: (context === null || context === void 0 ? void 0 : context.variant) !== 'fullModal', size: isTabletPortraitAndLarger || (context === null || context === void 0 ? void 0 : context.variant) === 'fullModal' ? 'compact' : 'regular', type: type, variant: variant, text: text !== null && text !== void 0 ? text : i18next.t($ => $.mf.modalsDialogs_modal.src.translations.json.submitButtonLabel), icon: icon, isDisabled: isDisabled, isLoading: isLoading, order: isTabletPortraitAndLarger ? 3 : 1, onClick: onClick, href: href, target: target, ...dataAriaProps }));
};
